import { Link } from "react-router-dom";
import { SiteLogo } from "../../assets";
import { useEffect, useState } from "react";

export default function MyQCHeader(): JSX.Element {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const scrollContainer = document.querySelector(".mqc-home");

        if (!scrollContainer) return;

        const handleScroll = () => {
            setIsScrolled(scrollContainer.scrollTop > 50);
        };

        scrollContainer.addEventListener("scroll", handleScroll, { passive: true });

        // initial check
        handleScroll();

        return () => {
            scrollContainer.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <header className={`sticky-top ${isScrolled ? "bg-white shadow-sm" : ""}`}>
            <div className="top-head">
                <div className="dark-header">
                    <div className="container d-flex justify-content-between fw-semibold py-1">
                        <p className="m-0">For US Healthcare Professionals</p>
                        <div className="d-lg-flex gap-2 d-none">
                            <a href="https://www.qutenzahcp.com/important-safety-information/" target="_blank" rel="noopener noreferrer" className="link-text">Important Safety Information</a>
                            <span> | </span>
                            <a href="https://www.qutenzahcp.com/pdfs/qutenza_prescribing_information.pdf" target="_blank" rel="noopener noreferrer" className="link-text">Full Prescribing Information</a>
                        </div>
                    </div>
                </div>
                <div className="light-header">
                    <div className="container d-flex justify-content-between justify-content-lg-end align-items-center gap-3 fw-semibold py-1">
                        <div className="d-flex d-lg-none gap-2 justify-content-between safety-text text-center fw-semibold">
                            <a href="https://www.qutenzahcp.com/important-safety-information/" target="_blank" rel="noopener noreferrer" className="link-text">Important Safety Information</a>
                            <a href="https://www.qutenzahcp.com/pdfs/qutenza_prescribing_information.pdf" target="_blank" rel="noopener noreferrer" className="link-text">Full Prescribing Information</a>
                        </div>
                        <Link to="/users/sign_in" type="button" target="_blank" className="btn-home btn-yellow-outline-dark btn-small d-flex align-items-center gap-3">
                            <span className="d-none d-lg-block">BI Portal – Log In</span>
                            <span className="d-block d-lg-none text-center">BI Portal Log In</span>
                            <svg className="d-none d-lg-block" width="11" height="15" viewBox="0 0 11 15" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.81772 6.02546H9.32622V4.05797L9.32515 3.87525H9.32052C9.20974 1.71852 7.53882 0 5.49996 0C3.46111 0 1.79026 1.71852 1.67948 3.87525H1.67378V6.02546H1.1819C0.529397 6.02546 0 6.59304 0 7.2932V13.7323C0 14.4324 0.529397 15 1.18197 15H9.81772C10.4707 15 11 14.4324 11 13.7323V7.2932C11 6.59304 10.4706 6.02546 9.81772 6.02546ZM4.91887 12.2041L3.7141 10.9123L4.27492 10.311L4.91895 11.0016L6.72523 9.06474L7.28598 9.66603L4.91887 12.2041ZM7.89134 6.02546H3.10859L3.10928 4.24681C3.10928 4.23912 3.10928 4.22996 3.10859 4.22574C3.10859 2.7282 4.18155 1.51027 5.49996 1.51027C6.81837 1.51027 7.89134 2.7282 7.89134 4.2212C7.89134 4.23004 7.89026 4.23921 7.89026 4.24689L7.89134 6.02546Z"
                                    fill="#21272A"/>
                            </svg>
                        </Link>
                        <button type="button" className="btn-home btn-yellow-outline-dark btn-small d-lg-flex align-items-center gap-3 d-none "
                                onClick={() =>
                                    document
                                        .getElementById("need-help-section")
                                        ?.scrollIntoView({ behavior: "smooth" })
                                }>
                            Need Help?
                            <svg width="13" height="14" viewBox="0 0 13 14" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0 1.34388V7.8901C0 8.63343 0.591 9.23397 1.3193 9.23397H6.03826L5.96174 12.6749C5.91 12.9828 6.25922 13.1955 6.5 13L10.6828 9.23296H11.6807C12.409 9.23296 13 8.63242 13 7.88908V1.34388C13 0.600542 12.409 0 11.6807 0H1.3193C0.591 0 0 0.600542 0 1.34388ZM9.09085 4.5461C9.09085 4.02758 9.50375 3.60731 10.0132 3.60731C10.5226 3.60731 10.9355 4.02758 10.9355 4.5461C10.9355 5.06461 10.5226 5.48489 10.0132 5.48489C9.50375 5.48489 9.09085 5.06461 9.09085 4.5461ZM5.57669 4.5461C5.57669 4.02758 5.98959 3.60731 6.49901 3.60731C7.00842 3.60731 7.42132 4.02758 7.42132 4.5461C7.42132 5.06461 7.00842 5.48489 6.49901 5.48489C5.98959 5.48489 5.57669 5.06461 5.57669 4.5461ZM2.06253 4.5461C2.06253 4.02758 2.47543 3.60731 2.98485 3.60731C3.49426 3.60731 3.90716 4.02758 3.90716 4.5461C3.90716 5.06461 3.49426 5.48489 2.98485 5.48489C2.47543 5.48489 2.06253 5.06461 2.06253 4.5461Z"
                                    fill="#212529" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div className="container d-flex justify-content-between align-items-center">
                <Link to="/" hrefLang="https://myqutenzaconnect.com/">
                    <img className="brand-logo m-0" src={SiteLogo} alt="My Qutenza logo" />
                </Link>
                <button type="button" className="btn-home btn-purple-outline bg-white btn-small d-flex align-items-center gap-3 d-lg-none "
                        onClick={() =>
                            document
                                .getElementById("need-help-section")
                                ?.scrollIntoView({ behavior: "smooth" })
                        }>
                    Need <br/> Help?
                </button>
            </div>
        </header>
    );
}
